import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { downloadCSV } from '../services/csvExport';
import { Budget } from '../types/budget';

interface ExportCSVButtonProps {
  budget: Budget & { id: number };
  showText?: boolean;
  className?: string;
}

export const ExportCSVButton: React.FC<ExportCSVButtonProps> = ({
  budget,
  showText = false,
  className = '',
}) => {
  const { t } = useTranslation();

  const handleExport = () => {
    // Format the budget name to be filename-friendly
    const fileName = budget.name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/[^a-z0-9]+/g, '-') // Replace special chars with hyphens
      .replace(/(^-+|-+$)/g, ''); // Remove leading/trailing hyphens

    downloadCSV(budget, fileName);
  };

  const baseClasses =
    'flex items-center rounded-md border border-slate-500 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:border-slate-500 dark:bg-surface-800 dark:text-slate-300 dark:hover:bg-surface-700';
  const buttonClasses = className ? `${baseClasses} ${className}` : baseClasses;

  return (
    <button
      onClick={handleExport}
      className={buttonClasses}
      title={t('budget.exportCSV')}
      data-attr="export-csv-button"
    >
      <ArrowDownTrayIcon className={`h-5 w-5 ${showText ? 'mr-2' : ''}`} />
      {showText && <span>{t('budget.exportCSV')}</span>}
    </button>
  );
};
